import { Tier } from '@backrs_ui/common-ui';

import { CareerQuestion, CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

import { AspirationsExplanations } from '../atoms/AspirationsExplanations';
import { MinimumTrackExplanation } from '../atoms/MinimumTrackExplanation';
import { MinimumTrackHeader } from '../atoms/MinimumTrackHeader';
import { SECTION_GAP } from '../result.constant';

type TrackExplanationProps = Readonly<{
  minimumTrack: Tier;
  entrepreneurshipRecommended: boolean;
  userResponseSet: CareerUserResponseSet;
  careerQuestions: CareerQuestion[];
}>;

export const TrackExplanation = ({
  minimumTrack,
  entrepreneurshipRecommended,
  userResponseSet,
  careerQuestions,
}: TrackExplanationProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={leftContainerStyle}>
        <MinimumTrackHeader minimumTrack={minimumTrack} />
        <MinimumTrackExplanation
          minimumTrack={minimumTrack}
          entrepreneurshipRecommended={entrepreneurshipRecommended}
        />
      </Box>
      <AspirationsExplanations userResponseSet={userResponseSet} questions={careerQuestions} />
    </Box>
  );
};

const leftContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: {
    xs: SECTION_GAP / 2,
    sm: SECTION_GAP,
  },
  maxWidth: '60.5%',
  '@media (max-width: 656px)': {
    maxWidth: '100%',
  },
};

const containerStyle: SxProps<Theme> = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  width: '100%',
  gap: {
    xs: SECTION_GAP / 2,
    sm: SECTION_GAP,
  },
  '@media (max-width: 656px)': {
    flexDirection: 'column',
  },
};
